export const prefix = process.env.NODE_ENV === "development" ? '/api' : ''
export const api =  process.env.NODE_ENV === "development" ? '' : 'https://www.energydt.cn/api/'
// export const api =  process.env.NODE_ENV === "development" ? '' : 'http://10.10.1.198:37086'
// export const api =  process.env.NODE_ENV === "development" ? '' : 'http://192.168.33.254:37086'
// export const api =  process.env.NODE_ENV === "development" ? '' : 'http://172.16.21.237:37086'
// export const api =  process.env.NODE_ENV === "development" ? '' : 'http://10.10.1.198:37086'
// export const api =  process.env.NODE_ENV === "development" ? '' : 'http://192.168.33.249'
